import { createSlice } from '@reduxjs/toolkit'

export const dataSourceSimulateSlice = createSlice({
    name: 'dataSourceSimulate',
    initialState: {
        result: null,
    },
    reducers: {
        setDataSourceSimulate: (state, action) => {
            state.result = action.payload;
        },
        clearDataSourceSimulate: (state) => {
            state.result = null;
        }
    },
})

export const { setDataSourceSimulate, clearDataSourceSimulate } = dataSourceSimulateSlice.actions;

export const getDataSourceSimulate = (state) => state.dataSourceSimulate.result;

export default dataSourceSimulateSlice.reducer